import {
  NonprofitOrgRole,
  FunderOrgToUserRelationship,
} from 'Generated/graphql-types'

type UserRoleOptions = {
  label: string
  value: NonprofitOrgRole | FunderOrgToUserRelationship
  details?: string
}

export const nonprofitOrgRoles: UserRoleOptions[] = [
  { label: 'Executive Director', value: NonprofitOrgRole.ExecutiveDirector },
  {
    label: 'Board Member',
    value: NonprofitOrgRole.BoardMember,
  },
  { label: 'Full-time Employee', value: NonprofitOrgRole.PaidStaff },
  { label: 'Part-time or Contract', value: NonprofitOrgRole.Staff },
  { label: 'Volunteer', value: NonprofitOrgRole.Volunteer },
  { label: 'Intern', value: NonprofitOrgRole.Intern },
  { label: 'AmeriCorps', value: NonprofitOrgRole.Americorps },
  { label: 'Other', value: NonprofitOrgRole.Other },
]

export const funderOrgRoles: UserRoleOptions[] = [
  {
    label: 'CEO / Director',
    value: FunderOrgToUserRelationship.CeoDirector,
  },
  {
    label: 'Community Outreach Manager',
    value: FunderOrgToUserRelationship.CommunityOutreachManager,
  },
  {
    label: 'Consultant',
    value: FunderOrgToUserRelationship.Consultant,
  },
  { label: 'Grants Manager', value: FunderOrgToUserRelationship.GrantsManager },
  {
    label: 'Marketing',
    value: FunderOrgToUserRelationship.Marketing,
  },
  {
    label: 'Program Officer',
    value: FunderOrgToUserRelationship.ProgramOfficer,
  },
  { label: 'Other', value: FunderOrgToUserRelationship.Other },
]

export const userRoles = [
  {
    label: 'ADMIN',
    value: 'ADMIN',
    details:
      'Access to all of the Resilia platform and platform-wide settings.',
  },
  {
    label: 'MEMBER',
    value: 'STAFF',
    details: 'Access to most of the Resilia platform.',
  },
]

export const funderUserRoles = [
  {
    label: 'ADMIN',
    value: 'ADMIN',
    details: '',
  },
  {
    label: 'MEMBER',
    value: 'MEMBER',
    details: '',
  },
]
